import { z, ZodType } from 'zod';

export type CashdeskBalance = {
	balance: number | null;
};

export const cashdeskBalanceSchema: ZodType<CashdeskBalance> = z.object({
	balance: z.number().nullable(),
});
